/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';

import ProductCard from '../../components/ecomm-product-card';

import { isMobile } from './../../components/breakpoints';
import { InventoryLvls } from '../../components/enums';
import Popup from './../../components/popup';

import { IEcommEventProductsViewProps } from './ecomm-event-products';

var moment = require('moment-timezone');

/**
 *
 * EcommEventProductsView component
 * @extends {React.PureComponent<IEcommEventProductsViewProps>}
 */
 export class EcommEventProductsView extends React.PureComponent<IEcommEventProductsViewProps> {
  public state: any = { width: 0, hasMounted: false, showPopup: false };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      const { context: { request: { user } } } = this.props;

      window.addEventListener('resize', this._updateDimensions);

      this.setState({ width: window.innerWidth, hasMounted: true, showPopup: user.isAuthenticated ? false : true });
    }
  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }

    const mobileMode = isMobile(this.state.width);

    const { config, context, gridSettings, data: { eventJson }, context: { request: { user } }, products, productsHaveAssociatedEvents, warehouse, serialAvailable, isRegistered } = this.props;

    const localeCode = this.props.context.request.locale.split('-')[0];

    const currentEvent = eventJson.result && eventJson.result.eventJson !== '' ? JSON.parse(eventJson.result.eventJson) : '';

    const today = moment.tz('Asia/Singapore').format('YYYY-MM-DD');
    const registrationClosingDate = currentEvent['StartDateTime'] ? moment(currentEvent['StartDateTime']).subtract(1, 'days') : undefined;
    const hasExpired = registrationClosingDate ? registrationClosingDate.isSameOrBefore(today) : true;

    const card = config.anchorID && config.anchorID !== '' ? 'anchor ecomm-event-products' : 'ecomm-event-products';
    const componentId = config.anchorID && config.anchorID !== '' ? config.anchorID : '';

    return (
      <div className={card} id={componentId}>
        <Popup showPopup={this.state.showPopup} name={config.title} url={user && user.signInUrl || ''} isMobile={mobileMode ? true : false} isPortalPopup={false} locale={localeCode} callback={this._handleCallback}/>
        <ul>
          {products.map((item: SimpleProduct, idx: number) =>
            <ProductCard
              key={idx}
              context={context}
              gridSettings={gridSettings}
              product={item}
              hasExpired={hasExpired || !serialAvailable[`${idx}`] || !productsHaveAssociatedEvents[`${idx}`] ||
              (warehouse.ProductWarehouseInventoryAvailabilities ? warehouse.ProductWarehouseInventoryAvailabilities[`${idx}`].PhysicalAvailableInventoryLevelCode !== InventoryLvls.AVAIL : true) ? true : false}
              isRegistered={isRegistered[`${idx}`] ? isRegistered[`${idx}`] : false}
              unavailableText={config.unavailableText ? config.unavailableText : ''}
              registeredText={config.registeredText ? config.registeredText : ''}
            />
          )}
        </ul>
      </div>
    );
  }

  private _updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  private _handleCallback = () => {
    this.setState({ showPopup: false});
  }
 }

 export default EcommEventProductsView;